// src/utils/services/AdvancedMD/labs.js
import axios from "axios";
import API_BASE_URL from "../../../config/apiConfig";

const LABS_BY_PATIENT_URL = `${API_BASE_URL}/api/advancedmd/labs`;

const authHeader = () => ({
  Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
});

/**
 * Obtiene los resultados de laboratorio de un paciente.
 * @param {string|number} patientId
 */
export async function getPatientLabs(patientId) {
  try {
    const url = `${LABS_BY_PATIENT_URL}/${encodeURIComponent(patientId)}`;
    const res = await axios.get(url, { headers: authHeader() });
    return res.data;
  } catch (err) {
    console.error("Error getPatientLabs:", err);
    throw err;
  }
}
